import React, { useState, useEffect } from 'react';
import showToast from '../../../../Shared/Utils/ToastNotification';
import { getOfferings, updateOfferingPrice, syncMdiOfferings } from '../services/OfferingService';
import './ManageOffering.scss';

const ManageOffering = () => {
  const [offerings, setOfferings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [priceChanges, setPriceChanges] = useState({});
  const [syncing, setSyncing] = useState(false);

  useEffect(() => {
    fetchOfferings();
  }, []);

  const fetchOfferings = async () => {
    try {
      const data = await getOfferings();
      setOfferings(data);
    } catch (error) {
      showToast('error', 'Failed to fetch offerings');
    } finally {
      setLoading(false);
    }
  };

  const handleSyncMdi = async () => {
    setSyncing(true);
    try {
      await syncMdiOfferings();
      showToast('success', 'MDI offerings synced successfully');
      await fetchOfferings();
    } catch (error) {
      showToast('error', error.response?.data?.message || 'Failed to sync MDI offerings');
    } finally {
      setSyncing(false);
    }
  };

  const handlePriceChange = (id, newPrice) => {
    const value = newPrice === '' ? '' : parseFloat(newPrice) || 0;
    setPriceChanges((prev) => ({ ...prev, [id]: value }));
  };

  const handleSave = async () => {
    if (Object.keys(priceChanges).length === 0) {
      showToast('info', 'No changes to save');
      return;
    }

    try {
      const updatePromises = Object.entries(priceChanges).map(([offeringId, price]) => updateOfferingPrice(offeringId, price));
      await Promise.all(updatePromises);
      showToast('success', 'Prices updated successfully');
      setPriceChanges({});
      await fetchOfferings();
    } catch (error) {
      showToast('error', 'Failed to update prices');
    }
  };

  if (loading) return <div className="text-center p-5">Loading...</div>;

  return (
    <div className="manage-offering-container">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 className="page-title" style={{ margin: 0 }}>
          Manage Offerings Prices
        </h2>
        <button className="btn btn-secondary" onClick={handleSyncMdi} disabled={syncing}>
          {syncing ? 'Syncing...' : 'Sync MDI Offerings'}
        </button>
      </div>
      <div className="offerings-table">
        <table className="table">
          <thead>
            <tr>
              <th>Title</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            {offerings.map((offering) => (
              <tr key={offering.id}>
                <td>{offering.title}</td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    value={priceChanges[offering.id] !== undefined ? priceChanges[offering.id] : offering.price || ''}
                    onChange={(e) => handlePriceChange(offering.id, e.target.value)}
                    step="0.01"
                    min="0"
                    placeholder="Enter price"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="text-center mt-3">
        <button className="btn btn-primary" onClick={handleSave} disabled={Object.keys(priceChanges).length === 0}>
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default ManageOffering;
